type DashboardProgressIconProps = {
  isComplete: boolean;
  progressPercent: number;
};

export function DashboardProgressIcon({ isComplete, progressPercent }: DashboardProgressIconProps) {
  return (
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 size-8 rounded-[20px] overflow-hidden">
      <svg className="size-8 -rotate-90" viewBox="0 0 32 32">
        <circle cx="16" cy="16" r="14" fill="none" stroke="#F4F4F5" strokeWidth="3" />
        <circle
          cx="16"
          cy="16"
          r="14"
          fill="none"
          stroke={isComplete ? "var(--innovera-green500)" : "#FF603E"}
          strokeWidth="3"
          strokeDasharray={`${2 * Math.PI * 14}`}
          strokeDashoffset={`${2 * Math.PI * 14 * (1 - progressPercent / 100)}`}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

